/**
* Accolades Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Accolades Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'accolades-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.splide--accolades-marquee' ).length ) {
        $( '.splide--accolades-marquee' ).each( function( key, val ) {
          const splideElement = $( val );
          // Duplicate slides if there are not enough
          const slides = splideElement.find( '.splide__slide' );
          const slideCount = slides.length;
          const requiredSlideCount = Math.ceil( $( window ).width() / slides.outerWidth( true ) );
          if ( slideCount < requiredSlideCount ) {
            const slidesToClone = requiredSlideCount - slideCount;
            for ( let i = 0; i < slidesToClone; i++ ) {
              slides.eq( i % slideCount ).clone().appendTo( splideElement.find( '.splide__list' ) );
            }
          }
          new Splide( val, {
            type: 'loop',
            autoWidth: true,
            autoScroll: {
              speed: 0.5,
            },
          } ).mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'accolades-marquee', COMPONENT );
} )( app );
